import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { ScanRequestStatus } from "@piiqtechnologies/ui-lib";
export const StatusPalette = {
    [ScanRequestStatus.SKIPPED]: "warning.main",
    [ScanRequestStatus.CANCELED]: "error.main",
    [ScanRequestStatus.SCHEDULED]: "success.main",
};
export const ScanRequestStatusValues = (status) => {
    const intl = useIntl();
    switch (status) {
        case ScanRequestStatus.SCHEDULED:
            return { color: StatusPalette[status], message: intl.formatMessage(messages.scheduledStatus) };
        case ScanRequestStatus.CANCELED:
            return { color: StatusPalette[status], message: intl.formatMessage(messages.canceledStatus) };
        case ScanRequestStatus.SKIPPED:
            return { color: StatusPalette[status], message: intl.formatMessage(messages.skippedStatus) };
        default:
            return { color: "text.primary", message: intl.formatMessage(messages.requestedStatus) };
    }
};
export default ScanRequestStatusValues;
